export default __webpack_public_path__ + "static/media/lotus-grey-2.af742804.svg";